"use strict";

var _slicedToArray = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadspediaApiBase = void 0;

var Lead_1 = require("./Lead");

var LeadspediaApiBase = /*#__PURE__*/function () {
  function LeadspediaApiBase(_ref) {
    var client = _ref.client,
        campaign = _ref.campaign;

    _classCallCheck(this, LeadspediaApiBase);

    this.plugins = [];
    this.actions = client;
    this.campaign = campaign;
  }
  /** Creates a new Lead instance */


  _createClass(LeadspediaApiBase, [{
    key: "new",
    value: function _new(initialState, leadProps) {
      var events = {};
      initialState = this.plugins.reduce(function (newInitialState, plugin) {
        if (plugin.onLoad) return plugin.onLoad(newInitialState);
        return newInitialState;
      }, initialState);
      var lead = new Lead_1.Lead(this.actions, {
        initialState: initialState,
        campaign: (leadProps === null || leadProps === void 0 ? void 0 : leadProps.campaign) || this.campaign,
        requiredPartialFields: leadProps === null || leadProps === void 0 ? void 0 : leadProps.requiredPartialFields,
        test: leadProps === null || leadProps === void 0 ? void 0 : leadProps.test,
        events: {
          onUpdate: function onUpdate(state) {
            var _a;

            (_a = events.onUpdate) === null || _a === void 0 ? void 0 : _a.forEach(function (cb) {
              cb(state);
            });
          },
          onMerge: function onMerge(mergeState, oldState) {
            return events.onMerge ? events.onMerge.reduce(function (newState, cb) {
              return cb(newState, oldState);
            }, mergeState) : mergeState;
          },
          onFieldUpdate: function onFieldUpdate(key, value) {
            return events.onFieldUpdate ? events.onFieldUpdate.reduce(function (newValue, cb) {
              return cb(key, newValue);
            }, value) : value;
          }
        }
      });
      this.plugins.forEach(function (plugin) {
        if (typeof plugin === "object") {
          return;
        }

        var pluginStruct = plugin(lead);
        Object.entries(pluginStruct).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              cb = _ref3[1];

          var eventListeners = events[key] || (events[key] = []);
          eventListeners.push(cb);
        });
      });
      return lead;
    }
  }, {
    key: "use",
    value: function use() {
      var _this$plugins;

      (_this$plugins = this.plugins).push.apply(_this$plugins, arguments);
    }
  }]);

  return LeadspediaApiBase;
}();

exports.LeadspediaApiBase = LeadspediaApiBase;